const route = {
  path: 'data-analysis',
  name: '数据分析',
  component: {
    render: e => e('router-view')
  },
  children: [
    {path: 'data-distribution', name: '数据分布', component: () => import('../views/dataAnalysis/dataDistribution.vue')},
    {path: 'frequency-statistics', name: '次数统计', component: () => import('../views/dataAnalysis/frequencyStatistics.vue')},
    {path: 'blood-glucose-statistics', name: '血糖统计', component: () => import('../views/dataAnalysis/bloodGlucoseStatistics.vue')}
  ]
}

export default route



// WEBPACK FOOTER //
// ./src/router/dataAnalysisRouter.js